import {ContainerSVG} from "components/waste-icons/svgs/ContainerSVG";
import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {IconFillingColoured} from "site-apps/assets/AssetColorsIcons";

const urlStatic = process.env?.REACT_APP_STATIC_URL || "/static";

const RouteAssetCard = ({asset}) => {
    const [tc] = useTranslation("choices");
    return (
        <div className="row card-asset-basic">
            <div className="col asset-svg">
                {asset.is_island ? (
                    <img src={`${urlStatic}/images/icons/waypoints/1-island.svg`} height={36} alt="Isla" />
                ) : (
                    <ContainerSVG type={asset.waste_type} />
                )}
                <div className="row overflow-x-hidden">
                    <small className="text-muted fs-08">{asset.is_island ? "Isla" : tc("wastes." + asset.waste_type)}</small>
                </div>
                <div className="row text-center">
                    <span className="h2 text-secondary">{asset.order}</span>
                </div>
            </div>
            <div className="col">
                <small className="text-muted">{asset.uid}</small>
                <div>{asset.full_address}</div>
                {asset.uuids ? <div className="small text-muted">{asset.uuids}</div> : <></>}
                {asset.filling ? (
                    <div>
                        <IconFillingColoured value={asset.filling} />{" "}
                    </div>
                ) : (
                    <></>
                )}
            </div>
            <div className="col icons">
                {asset.has_device ? <FontAwesomeIcon icon="wifi" title="Tiene sensor" /> : <></>}
                {asset.has_route ? <FontAwesomeIcon icon="truck-fast" title="Tiene Ruta" /> : <></>}
                {asset.has_alert ? <FontAwesomeIcon icon="triangle-exclamation" title="Tiene alerta" /> : <></>}
            </div>
        </div>
    );
};
export default RouteAssetCard;
